var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var promiseToCallback = require('promise-to-callback');

module.exports = createAsyncMiddleware;

function createAsyncMiddleware(asyncMiddleware) {
  return function (req, res, next, end) {
    var nextDonePromise = null;
    var finishedPromise = asyncMiddleware(req, res, getNextPromise);
    promiseToCallback(finishedPromise)(function (err) {
      // async middleware ended
      if (nextDonePromise) {
        // next handler was called - complete nextHandler
        promiseToCallback(nextDonePromise)(function (nextErr, nextHandlerSignalDone) {
          // nextErr is only present if something went really wrong
          // if an error is thrown after `await next()` it appears as `err` and not `nextErr`
          if (nextErr) {
            console.error(nextErr);
            return end(nextErr);
          }

          nextHandlerSignalDone(err);
        });
      } else {
        // next handler was not called - complete middleware
        end(err);
      }
    });

    function getNextPromise() {
      return _getNextPromise.apply(this, arguments);
    }

    function _getNextPromise() {
      _getNextPromise = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nextDonePromise = getNextDoneCallback();
                _context.next = 3;
                return nextDonePromise;

              case 3:
                return _context.abrupt("return", undefined);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getNextPromise.apply(this, arguments);
    }

    function getNextDoneCallback() {
      return new Promise(function (resolve) {
        next(function (cb) {
          return resolve(cb);
        });
      });
    }
  };
}